<div class="payment-card" role="listitem">
  <!-- Header -->
  <div class="card-header">
    <div class="header-left">
      <mat-icon class="method-icon" aria-hidden="true">credit_card</mat-icon>
      <span class="method-title">Debit card</span>
    </div>
    <button mat-icon-button class="delete-btn" (click)="onRemove()" aria-label="Remove debit card payment method">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <div class="card-body">

    <div class="terminal-amount-display">
      <span class="fee-label">Amount</span>
      <span class="fee-amount">{{ method.amount | currency }}</span>
    </div>

    <ng-container [ngSwitch]="flowState">

      <!-- idle -->
      <div *ngSwitchCase="'idle'" class="terminal-flow-row">
        <mat-form-field appearance="outline" class="terminal-select">
          <mat-label>Terminal</mat-label>
          <mat-select [(ngModel)]="selectedDeviceId" (ngModelChange)="onTerminalChange($event)" aria-label="Select POS terminal">
            <mat-option *ngFor="let t of terminals" [value]="t.deviceId">{{ t.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <button
          mat-icon-button
          type="button"
          (click)="onRefreshTerminals()"
          [disabled]="loadingTerminals"
          aria-label="Refresh terminal list"
        >
          <mat-icon>refresh</mat-icon>
        </button>
        <button
          mat-flat-button
          color="primary"
          class="send-btn"
          [disabled]="!selectedDeviceId"
          (click)="onSendToTerminal()"
        >
          SEND TO TERMINAL
        </button>
      </div>

      <!-- sending -->
      <div *ngSwitchCase="'sending'" class="terminal-status info" role="status" aria-live="polite">
        <mat-spinner diameter="18"></mat-spinner>
        <span class="status-text">Sending to terminal…</span>
      </div>

      <!-- waiting -->
      <div *ngSwitchCase="'waiting'" class="terminal-status info" role="status" aria-live="polite">
        <mat-spinner diameter="18"></mat-spinner>
        <span class="status-text">Waiting for customer…</span>
        <button mat-stroked-button color="warn" class="cancel-btn" (click)="onCancel()" aria-label="Cancel terminal transaction">
          CANCEL
        </button>
      </div>

      <!-- approved -->
      <div *ngSwitchCase="'approved'" class="terminal-status success" role="status" aria-live="polite">
        <mat-icon class="status-icon" aria-hidden="true">check_circle</mat-icon>
        <span class="status-text">
          Approved — {{ method.cardType }} &bull;{{ method.cardLastFour }}
          <ng-container *ngIf="approvedStatus?.processingFee as fee">&middot; processor fee {{ fee | currency }}</ng-container>,
          conf {{ approvedStatus?.confirmationNumber }}
        </span>
      </div>

      <!-- failed -->
      <div *ngSwitchCase="'failed'" class="terminal-status warning" role="alert" aria-live="assertive">
        <mat-icon class="status-icon" aria-hidden="true">error</mat-icon>
        <span class="status-text">{{ errorMessage }}</span>
        <button mat-stroked-button color="warn" class="connect-btn" (click)="onTryAgain()" aria-label="Retry sending to terminal">
          TRY AGAIN
        </button>
      </div>

    </ng-container>
  </div>
</div>
